module.exports = __webpack_public_path__ + "img/logo_kommersant.cf023942.png";